import {Injectable} from '@angular/core';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import * as globals from '../globals';

@Injectable()
export class SetPasswordService {

    private setpasswordUrl = globals.APIURL + '/setpassword';

    constructor (private http: Http) {
    }

    setPassword(userName, oldPassword, newPassword): Observable<string> {
      console.log('setPassword service method called');

      // Got to do this because we don't want to send password anymore
      let body = JSON.stringify({username: userName, oldpassword: oldPassword,
        newpassword: newPassword});

      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers });
      return this.http.post(this.setpasswordUrl, body, options)
        .map(this.extractData)
        .catch(this.handleError);
    }

    private extractData(res: Response) {
      let body = res.json();
      return body || { };
    }

    handleError(error: any) {
      // In a real world app, we might use a remote logging infrastructure
      // We'd also dig deeper into the error to get a better message
      let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
      return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/setpassword/setpassword.service.ts